import uuid from 'uuid/v4';

import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api';

export interface IDebugTriggers {
	addTrigger: (featureId: string, featureName?: string, featureDescription?: string) => void;
	clear: () => void;
	hasTriggers: boolean;
	useNextTrigger: () => Partial<NudgeRecommendationDetails> | undefined;
}

/**
 * Simulates Convo AI nudge recommendations. When using the debug trigger, the service
 * request is skipped.
 */
export class DebugTriggers implements IDebugTriggers {
	private triggerQueue: Partial<NudgeRecommendationDetails>[] = [];

	get hasTriggers(): boolean {
		return Boolean(this.triggerQueue.length);
	}

	public addTrigger(featureId: string, featureName?: string, featureDescription?: string) {
		this.triggerQueue.push({
			nudge_id: uuid(),
			feature_details: {
				feature_id: featureId,
				feature_name: featureName || 'Debug Nudge',
				feature_description: featureDescription || 'A nudge added for debugging',
			},
		} as Partial<NudgeRecommendationDetails>);
	}

	public clear() {
		this.triggerQueue = [];
	}

	public useNextTrigger(): Partial<NudgeRecommendationDetails> | undefined {
		return this.triggerQueue.shift();
	}
}
